'use client';

import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@emotion/react';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import NextAppDirEmotionCacheProvider from './EmotionCache';
import { muiTheme, defaultTheme } from './themes';

export default function ThemeRegistry({ children }: { children: React.ReactNode }) {
    return (
        <NextAppDirEmotionCacheProvider options={{ key: 'mui' }}>
            <MUIThemeProvider theme={muiTheme}>
                <ThemeProvider theme={(muiTheme) => ({ ...defaultTheme, ...muiTheme })}>
                    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                    <CssBaseline />
                    {children}
                </ThemeProvider>
            </MUIThemeProvider>
        </NextAppDirEmotionCacheProvider>
    );
}
